var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_12294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 38.5C63 40.845 63 43.155 63 45.5C67.2 45.5 72.66 45.5 77 45.5C77 43.155 77 40.845 77 38.5C72.66 38.5 67.2 38.5 63 38.5Z",
    fill: "#D5D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 61.635C59.36 64.12 63.735 67.41 67.2 70C68.6 68.145 70 66.255 71.4 64.4C67.935 61.81 63.56 58.52 60.2 56C58.8 57.89 57.4 59.78 56 61.635Z",
    fill: "#D5D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4 19.6C70 17.745 68.6 15.855 67.2 14C63.735 16.59 59.36 19.88 56 22.4C57.4 24.255 58.8 26.145 60.2 28C63.56 25.48 67.935 22.225 71.4 19.6Z",
    fill: "#D5D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 31.5C10.15 31.5 7 34.65 7 38.5V45.5C7 49.35 10.15 52.5 14 52.5H17.5V66.5H24.5V52.5H28L45.5 63V21L28 31.5H14ZM31.605 37.485L38.5 33.355V50.645L31.605 46.515L29.925 45.5H28H14V38.5H28H29.925L31.605 37.485Z",
    fill: "#D5D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.25 42C54.25 37.345 52.22 33.145 49 30.275V53.69C52.22 50.855 54.25 46.655 54.25 42Z",
    fill: "#D5D1D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_12294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.60003afb3aed6d5682e055f6447e2ae0.svg";
export { ForwardRef as ReactComponent };